__turbopack_context__.v({
  "heading": "section-seo-module__mPxV-q__heading",
});
